export const roundToFloat = (n: number, numberDigits: number) => {
    //check if n is a number
    if (typeof n !== "number") {
        //try to convert n to a number
        n = parseFloat(n as unknown as string);
        if (isNaN(n)) {
            console.error(`roundToFloat: ${n} is not a number`);
            return null;
        }
    }
    return Math.round((n + Number.EPSILON) * Math.pow(10, numberDigits)) / Math.pow(10, numberDigits);
};
